// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { z } from 'zod';

export const customSectionSchema = z.object({
  title: z.string().min(1, 'Section title is required.').max(255, 'Title must be 255 characters or less.'),
  is_visible: z.boolean().optional(),
});

export type CustomSectionFormData = z.infer<typeof customSectionSchema>;

export const customSectionEntrySchema = z.object({
  title: z.string().max(255, 'Title must be 255 characters or less.').optional().or(z.literal('')),
  subtitle: z.string().max(255, 'Subtitle must be 255 characters or less.').optional().or(z.literal('')),
  description: z.string().max(10000, 'Description must be 10,000 characters or less.').optional().or(z.literal('')),
  start_date: z.string().max(50).optional().or(z.literal('')),
  end_date: z.string().max(50).optional().or(z.literal('')),
  url: z.string().max(2048, 'URL must be 2,048 characters or less.').optional().or(z.literal('')),
});

export type CustomSectionEntryFormData = z.infer<typeof customSectionEntrySchema>;
